import LoadingSkeleton from 'Components/LoadingSkeleton/MainSkeleton/LoadingSkeleton';
import { jwtDecode } from 'jwt-decode';
import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { setDeeplinking } from '../../Redux/Reducers/OnboardingReducer';

const SessionHandler = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch()
  const [isValidating, setIsValidating] = useState(true);
  const hasLoggedUrl = useRef(false); // Track if URL has been logged

  // useEffect(() => {
  //   const validateToken = async () => {
  //     if (!hasLoggedUrl.current) {
  //       const params = new URLSearchParams(window.location.search);
  //       const backLinkUrl = params.get('back_link_url');
  //       if (backLinkUrl) {
  //         // dispatch(setDeeplinking(location.pathname));
  //         dispatch(setDeeplinking(location.pathname + location.search));
  //       }

  //       hasLoggedUrl.current = true;
  //     }

  //     const token = localStorage.getItem('objectId');

  //     if (!token) {
  //       console.log('No token found');
  //       localStorage.setItem('previousPath', location.pathname);
  //       navigate('/login', { replace: true });
  //       setIsValidating(false);
  //       return;
  //     }

  //     try {
  //       const decodedToken = jwtDecode(token);
  //       const currentTime = Date.now() / 1000;

  //       if (decodedToken.exp < currentTime) {
  //         console.log('Token expired');
  //         localStorage.removeItem('objectId');
  //         localStorage.setItem('previousPath', location.pathname);
  //         navigate('/login', { replace: true });
  //         setIsValidating(false);
  //         return;
  //       }

  //       setIsValidating(false);
  //     } catch (error) {
  //       localStorage.removeItem('objectId');
  //       localStorage.setItem('previousPath', location.pathname);
  //       navigate('/login', { replace: true });
  //       setIsValidating(false);
  //     }
  //   };

  //   validateToken();
  // }, [navigate, location.pathname, dispatch]);

  useEffect(() => {
    const validateToken = async () => {
      if (!hasLoggedUrl.current) {
        // if (location.search) {
        //   dispatch(setDeeplinking(location.pathname + location.search));
        // }

        // hasLoggedUrl.current = true;
        const params = new URLSearchParams(window.location.search);
        const backLinkUrl = params.get('back_link_url');
        const organizationId = params.get('organizationId')
        // console.log("navigationMMMMM", navigation)
        // console.log("window.location-555", window.location)
        if (backLinkUrl) {
          // dispatch(setDeeplinking(location.pathname));
          dispatch(setDeeplinking(location.pathname + location.search));
        }
        else if(organizationId){
          dispatch(setDeeplinking(location.pathname + location.search));
        }
      
        hasLoggedUrl.current = true;
      }

      const token = localStorage.getItem('objectId');

      if (!token) {
        console.log('No token found');
        localStorage.setItem('previousPath', location.pathname);
        navigate('/login', { replace: true });
        setIsValidating(false);
        return;
      }

      try {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;

        if (decodedToken.exp < currentTime) {
          console.log('Token expired');
          localStorage.removeItem('objectId');
          localStorage.setItem('previousPath', location.pathname);
          navigate('/login', { replace: true });
          setIsValidating(false);
          return;
        }

        setIsValidating(false);
      } catch (error) {
        localStorage.removeItem('objectId');
        localStorage.setItem('previousPath', location.pathname);
        navigate('/login', { replace: true });
        setIsValidating(false);
      }
    };

    validateToken();
  }, [navigate, location.pathname, dispatch]);

  // Show loading while validating token
  if (isValidating) {
    return <div style={{ width: '92vw', justifyContent: 'center', display: 'flex' }}><LoadingSkeleton /></div>;
  }

  return <>{children}</>;
};

export default SessionHandler;